export enum EProductImageMetadataKey {
  SCENE_NAME = 'sceneName',
}
